<template>
  <div class="wifi-card">
    <div class="wifi-card__header">
      <span>
        <span class="icon-wifi"></span>
        <div class="wifi-card__header--text">{{ header }}</div>
      </span>
      <span
        @click.prevent="openModal"
        class="edit-btn mdi mdi-border-color"
      ></span>
    </div>
    <div class="wifi-card__container">
      <div class="wifi-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.wifi_ap.work_mode") }}
        </div>
        <div class="text">
          {{ translate("device.config_dashboard.wifi_ap.access_point") }}
        </div>
      </div>
      <div class="wifi-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.wifi_ap.interface") }}
        </div>
        <div class="text">
          {{ header }}
        </div>
      </div>
      <div class="wifi-card__container--row">
        <div class="title">SSID</div>
        <div class="text">
          {{ dataWifiAp.ssids ? dataWifiAp.ssids : "N/A" }}
        </div>
      </div>
      <div class="wifi-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.wifi_ap.frequency") }}
        </div>
        <div class="text">
          {{ (dataWifiAp.band == "2" ? dataWifiAp.band = "2.4" : (dataWifiAp.band ? dataWifiAp.band : "N/A"))  }}
        </div>
      </div>
      <div class="wifi-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.wifi_ap.channel") }}
        </div>
        <div class="text">
          {{
            dataWifiAp.channel ? dataWifiAp.channel : "N/A"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WifiApModal from "./WifiApModal.vue";

export default {
  name: "Wi-fi_client",
  components: {},
  props: {
    header: String,
    dataWifiAp: Object,
    lanIfaces: Array,
  },
  data() {
    return {
      //apClientData: [],
    };
  },
  computed: {},
  methods: {
    openModal(val) {
      var t = this.$createElement(WifiApModal, {
        props: {
          dataWifiAp: this.dataWifiAp,
          header: this.header,
          lanIfaces: this.lanIfaces,
        },
        on: {
          close: () => {
            this.$modal.hide("dynamic-modal");
          },
          update: (data) => {
            this.$emit("update", data);
          },
          delete: (val) => {
            this.$emit("delete", val);
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: "auto",
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: "dynamic-modal",
        }
      );
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.wifi-card {
  color: #fff;
  background: #f4f3ef;
  border-radius: 6px;
  max-width: 380px;
  width: 100%;
  margin-right: 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 2px #ccc5b980;
  border: 1px solid #ccc;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 19px;
    border-bottom: 1px solid #cecfd1;
    background: #e2ecdc;
    span {
      display: flex;
      align-items: center;
    }
    .icon-wifi {
      margin-right: 10px !important;
      font-size: 20px !important;
      color: black;
    }
    .mdi-wifi-off {
      color: gray;
    }

    .edit-btn {
      font-size: 22px;
      cursor: pointer;
      color: black;
    }

    &--text {
      color: black;
      font-size: 13px;
    }
    &--more {
      text-transform: uppercase;
      color: gray;
      font-size: 11px;
    }
  }
  &__container {
    padding: 5px 19px;

    &--row {
      margin: 14px 0;
      display: flex;
      align-items: center;
      .title {
        max-width: 150px;
        font-size: 13px;
        width: 100%;
        margin-right: 10px;
        color: black;
        text-align: left;
      }
      .text {
        display: flex;
        font-size: 13px;
        color: black;
        align-items: center;
        .db-indicator {
          margin-right: 10px;
          padding: 4px 10px;
          border-radius: 2px;
          color: white;
        }
        .changes {
          opacity: 0.4;
          color: gray;
          font-size: 13px;
          border-bottom: 1px solid gray;
          border-bottom-style: dashed;
        }
      }
    }
  }
}
</style>
